<template>
<section class="">
  <h1 class="title">Gallery</h1>
  <swiper class="" :options="swiperOption">
  <swiper-slide class="slide-5">
      <img src="../../../static/photos/OOSH_002.jpg">
  </swiper-slide>
  <swiper-slide class="slide-6">
    <img src="../../../static/photos/OOSH_003.jpg">
  </swiper-slide>
  <swiper-slide class="slide-7">
    <img src="../../../static/photos/OOSH_007.jpg">
  </swiper-slide>
  <swiper-slide class="slide-8">
    <img src="../../../static/photos/OOSH_012.jpg">
  </swiper-slide>
  <swiper-slide class="slide-1">
    <img src="../../../static/photos/OOSH_016.jpg">
  </swiper-slide>
  <swiper-slide class="slide-2">
    <img src="../../../static/photos/OOSH_025.jpg">
  </swiper-slide>
  <swiper-slide class="slide-3">
    <img src="../../../static/photos/OOSH_026.jpg">
  </swiper-slide>
  <swiper-slide class="slide-4">
    <img src="../../../static/photos/OOSH_028.jpg">
  </swiper-slide>
    <swiper-slide class="slide-4">
    <img src="../../../static/photos/OOSH_044.jpg">
  </swiper-slide>
    <swiper-slide class="slide-4">
    <img src="../../../static/photos/OOSH_057.jpg">
  </swiper-slide>
    <swiper-slide class="slide-4">
    <img src="../../../static/photos/OOSH_058.jpg">
  </swiper-slide>
    <swiper-slide class="slide-4">
    <img src="../../../static/photos/OOSH_065.jpg">
  </swiper-slide>
    <swiper-slide class="slide-4">
    <img src="../../../static/photos/OOSH_078.jpg">
  </swiper-slide>
    <swiper-slide class="slide-4">
    <img src="../../../static/photos/OOSH_082.jpg">
  </swiper-slide>
    <swiper-slide class="slide-4">
    <img src="../../../static/photos/OOSH_086.jpg">
  </swiper-slide>
        <div class="swiper-pagination swiper-pagination-white is-hidden-mobile" slot="pagination"></div>
        <div class="swiper-button-prev swiper-button-black is-hidden-mobile" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-black is-hidden-mobile" slot="button-next"></div>
  </swiper>
</section>
</template>
<script>
import { swiper } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'Swiper',
  components: { swiper },
  data () {
    return {
      swiperOption: {
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        loopedSlides: 4,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>

<style scoped>
section {
  background: #fff;
}
.gallery {
  margin: 0 auto;
}
.swiper-container {
  background-color: #fff;
  height: 600px;
  width: 80vw;
  margin-bottom: 60px;
}
@media screen and (max-width: 796px) {
  .swiper-container {
    height: 300px;
  }
}

.swiper-slide {
  background: #fff;
}
.swiper-slide img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
    box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
}

.swipe-con {
  padding: 0 auto 0 auto;
  margin-bottom: 60px;
}

h1 {
  padding: 60px;
  margin-bottom: 0 !important;
}

.swiper-slide {
  width: 25%;
  height: 100%;
}

.swiper-button-next,
.swiper-button-prev {
  color: #2d3436;
}
.hide {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Gallery.vue